import { EnumWebOrderStep } from "nlb-buy-go-library";
import { RouteLocationNormalizedLoaded } from "vue-router";

//limit create views
const LimitStart = () => import("@views/app/limit/limit-start.vue");
const LimitCreateView = () => import("@views/app/limit/limit-create-view.vue");
const Verification = () => import("@views/app/limit/verification-view.vue");
const VerificationEmail = () => import("@views/app/limit/verification-email-view.vue");
const Login = () => import("@views/app/limit/login-view.vue");
const PrecheckView = () => import("@views/app/limit/precheck-view.vue");
const PersonalInfoView = () => import("@views/app/limit/personal-info-view.vue");
const IdentificationInfoView = () => import("@views/app/limit/identification-info-view.vue");
const EmploymentInfoView = () => import("@views/app/limit/employment-info-view.vue");
const FinancialInfoView = () => import("@views/app/limit/financial-info-view.vue");
const CalculationResultView = () => import("@views/app/limit/calculation-result-view.vue");
const PreapprovedLimitFinancing = () => import("@views/app/limit/preapproved-limit-financing.vue");
const PreapprovedLimitEnd = () => import("@views/app/limit/preapproved-limit-end.vue");
const PreapprovedEndFailView = () => import("@views/app/limit/preaaproved-limit-end-fail-view.vue");
const LimitCalculationFailView = () => import("@views/app/limit/limit-calculation-fail-view.vue");
const LimitPreapproveDeclineView = () => import("@views/app/limit/limit-preapprove-decline-view.vue");
const LimitPasswordResetTaxNumView = () => import("@/app/views/app/limit/limit-password-reset-tax-number-view.vue");
const LimitEmailResumeView = () => import("@/app/views/app/public/limit-email-resume-view.vue");


export const limitCreateRoutes = [
    {
        component: LimitCreateView,
        name: "limitCreate_home",
        redirect: { name: "limit_zacetek" },
        path: "limit",
        children: [
            {
                name: "limit_zacetek_redirect",
                path: "zacetek",
                redirect: { name: "limit_zacetek" },
            },
            {
                component: LimitStart,
                name: "limit_zacetek",
                path: "start/:reference?",
                props: true,
            },
            {
                component: Verification,
                name: "LimitVerificationPhone",
                path: "verification/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SendPin", action: "sendPinCode", visible: true },
                        { name: "ConfirmPin", action: "confirmPinCode", visible: true },
                    ],
                    navigation: { login: "LimitLogin", endFail: "LimitCalculationFail", verifyEmail: "LimitVerificationEmail" },
                    stepId: EnumWebOrderStep.LIMIT_verification_phone,
                    gtm_data: {
                        event: "funnel_2",
                        funnel_name: "izracun_limita",
                        step: 2,
                        step_name: "telefon",
                        cta_name: "Nadaljuj"
                    }
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },          
            },
            {
                component: VerificationEmail,
                name: "LimitVerificationEmail",
                path: "verification-email/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SendValidationMail", action: "sendVerificationEmail", visible: true }
                    ],
                    navigation: { endFail: "LimitCalculationFail", end: "ProcessEndScreen" },
                    stepId: EnumWebOrderStep.LIMIT_verification_email,
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },        
            },

            {
                component: LimitPasswordResetTaxNumView,
                name: "LimitPassworResetTaxNum",
                path: "password/reset/tax-number/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Back", action: "Back", visible: true },
                        { name: "Next", action: "passwordResetRequest", visible: true }
                    ],
                    navigation: { 
                        login: "LimitLogin",
                        end: "ProcessEndScreen"
                    },
                    stepId: EnumWebOrderStep.LIMIT_pass_reset_tax,
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },            
            }, 
            {
                component: Login,
                name: "LimitLogin",
                path: "passcode/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "login", visible: true }
                    ],
                    navigation: { precheck: "LimitPrecheck", endFail: "LimitCalculationFail" },
                    stepId: EnumWebOrderStep.LIMIT_login,
                    gtm_data: {
                        event: "funnel_3",
                        funnel_name: "izracun_limita",
                        step: 3,
                        step_name: "geslo",
                        cta_name: "Nadaljuj"
                    }
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },             
            },    
            {
                component: PrecheckView,
                name: "LimitPrecheck",
                path: "precheck/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "executePrecheck", visible: true }
                    ],
                    navigation: { nextStep: "LimitPersonalInfo", endFail: "LimitCalculationFail" },
                    stepId: EnumWebOrderStep.LIMIT_precheck,
                    gtm_data: {
                        event: "funnel_4",
                        funnel_name: "izracun_limita",
                        step: 4,
                        step_name: "davcna_stevilka",
                        cta_name: "Nadaljuj"
                    }
                },  
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },            
            },
            {
                component: PersonalInfoView,
                name: "LimitPersonalInfo",
                path: "personal-information/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "LimitIdentificationInfo", endFail: "LimitCalculationFail" },
                    stepId: EnumWebOrderStep.LIMIT_personal_info,
                    gtm_data: {
                        event: "funnel_5",
                        funnel_name: "izracun_limita",
                        step: 5,
                        step_name: "osebni_podatki",
                        cta_name: "Nadaljuj"
                    }
                },
                stepId: EnumWebOrderStep.LIMIT_personal_info,

                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },              
            },
            {
                component: IdentificationInfoView,
                name: "LimitIdentificationInfo",
                path: "identification-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "LimitEmploymentFinancialInfo"},
                    stepId: EnumWebOrderStep.LIMIT_identification_info,
                    gtm_data: {
                        event: "funnel_6",
                        funnel_name: "izracun_limita",
                        step: 6,
                        step_name: "identifikacijski_podatki",
                        cta_name: "Nadaljuj"
                    }
                }, 
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },            
            },
            {
                component: EmploymentInfoView,
                name: "LimitEmploymentFinancialInfo",
                path: "employment-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "LimitFinancialInfo" },
                    stepId: EnumWebOrderStep.LIMIT_employment_info,
                    gtm_data: {
                        event: "funnel_7",
                        funnel_name: "izracun_limita",
                        step: 7,
                        step_name: "podatki_zaposlitev",
                        cta_name: "Nadaljuj"
                    }
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                }, 
            },            
            {
                component: FinancialInfoView,
                name: "LimitFinancialInfo",
                path: "financial-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "LimitCalculationInfo", endFail: "LimitCalculationFail" },
                    stepId: EnumWebOrderStep.LIMIT_financial_info,
                    gtm_data: {
                        event: "funnel_9",
                        funnel_name: "izracun_limita",
                        step: 9,
                        step_name: "financni_podatki",
                        cta_name: "Nadaljuj"
                    }
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                },  
            },
            {
                component: CalculationResultView,
                name: "LimitCalculationInfo",
                path: "calculation/:id",
                props: true,
                meta: {
                    navigation: {
                        endFail: "LimitCalculationFail"
                    },
                    stepId: EnumWebOrderStep.LIMIT_calculation_result,
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                }, 
                // meta: {
                //     buttons: [
                //         { name: "Preapprove", action: "preapprove", visible: true }
                //     ],
                //     navigation: { nextStep: "preapprovedLimitCreate_home", endFail: "EndFail" },
                // },
            },
            {
                component: LimitCalculationFailView,
                name: "LimitCalculationFail",
                path: "calculation/end-fail/:id",
                props: true,          
                meta: {
                    stepId: EnumWebOrderStep.LIMIT_calculation_fail,
                },
            },
            
            {
                component: LimitPreapproveDeclineView,
                name: "LimitPreapproveDecline",
                path: "preapprove-decline/:id",
                props: true,
                meta: {
                    stepId: EnumWebOrderStep.LIMIT_preapproved_decline,
                },
            }, 
        ]
    },
];

export const preapprovedLimitCreateRoutes = [
    {
        component: LimitCreateView,
        name: "preapprovedLimitCreate_home",
        redirect: { name: "PreapprovedStart" },
        path: "preapproved",
        children: [
            {
                component: PreapprovedLimitFinancing,
                name: "PreapprovedStart",
                path: "financing/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SignPreapproved", action: "PreapprovedVloga", visible: true }
                    ],
                    navigation: { nextStep: "PreapprovedVloga", endSuccess: "PreapprovedLimitEndSuccess", endFail: "PreapprovedLimitEndFail" },
                    stepId: EnumWebOrderStep.LIMIT_preapproved_start,
                    gtm_data: {
                        event: "confirmation_2",
                        funnel_name: "pred_odobritvijo",
                        step: 2,
                        step_name: "mesecni_prihodek",
                        cta_name: "Podpiši_vlogo"
                    }
                },
                beforeEnter: (to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded) => {
                    if(from.name == undefined){
                        return { name: "limitCreate_home" };
                    }
                    else{
                        window.onbeforeunload = () => {
                            return confirm();
                        }
                    }
                }, 
            },
            {
                component: PreapprovedLimitEnd,
                name: "PreapprovedLimitEndSuccess",
                path: "end/:id",
                props: true,          
                meta: {
                    stepId: EnumWebOrderStep.LIMIT_preapproved_success,
                },
            },
            {
                component: PreapprovedEndFailView,
                name: "PreapprovedLimitEndFail",
                path: "end-fail/:id",
                props: true,            
                meta: {
                    stepId: EnumWebOrderStep.LIMIT_preapproved_fail,
                },
            },
           
        ]
    },
    {
        component: LimitEmailResumeView,
        name: "LimitEmailResume",
        path: "preapproved/resume-limit/:id",
        props: true,
        meta: {
            buttons: []
        }
    },
];